import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const SITE_URL = `${BACKEND_URL}/api/site/`;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return "Une erreur est survenue. Réessaie.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const field = detail[0]?.loc?.slice(-1)[0];
    if (field === "email") return "Adresse email invalide.";
    if (field === "password") return "Le mot de passe doit contenir au moins 8 caractères.";
    return detail.map((d) => d?.msg).filter(Boolean).join(" ");
  }
  return String(detail);
}

export async function fetchMe() {
  try {
    return (await api.get("/auth/me")).data;
  } catch {
    try {
      await api.post("/auth/refresh");
      return (await api.get("/auth/me")).data;
    } catch {
      return false;
    }
  }
}

export const goToSite = () => window.location.assign(SITE_URL);
